import { bootstrapApplication } from '@angular/platform-browser';
import { provideMarkdown } from 'ngx-markdown'; // ✅ Add this
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

// If you're defining appConfig elsewhere:
bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    ...appConfig.providers,
    provideMarkdown() // ✅ Register Markdown globally
  ]
}).catch((err) => console.error(err));
